import React from "react";
import { IconContainer } from "./IconContainer";

export const PlusIcon = ({ ...props }) => (
  <IconContainer {...props} viewBox="0 0 16 16">
    <path
      d="M8.60313 3.79922C8.60313 3.46785 8.3345 3.19922 8.00313 3.19922C7.67175 3.19922 7.40313 3.46785 7.40313 3.79922V7.39922H3.80313C3.47175 7.39922 3.20312 7.66785 3.20312 7.99922C3.20312 8.33059 3.47175 8.59922 3.80313 8.59922L7.40313 8.59922V12.1992C7.40313 12.5306 7.67175 12.7992 8.00313 12.7992C8.3345 12.7992 8.60313 12.5306 8.60313 12.1992V8.59922L12.2031 8.59922C12.5345 8.59922 12.8031 8.33059 12.8031 7.99922C12.8031 7.66785 12.5345 7.39922 12.2031 7.39922H8.60313V3.79922Z"
      fill="currentColor"
    />
  </IconContainer>
);
